/*
*
* Odd for 1x2(4,11) , ML(12,13)
*
*/

"use strict";

import Vue from 'vue'
import VueFilterNumber from '@/vue/filters/vue-filter-number'
import allBetMixin from '@/vue/mixins/allBet'
import EventBus from '@/vue/events/event-bus'
import minibet from '@/vue/components/mini-bet'

import {
  mapGetters,
} from 'vuex'

Vue.component('oddDbch',{
  components: {
    minibet,
  },
  computed: {
    ...mapGetters([
      'sportMiniBet',
    ]),
    betForm () {
      return this.$store.getters.betForm[0]
    },
  },
  mixins: [allBetMixin],
  name:'oddDbch',
  template: `
    <div :id="getOddUniqueId(event)" class="odds od2" :class="[getOdCls(mode,betType,event), getClass(event, isNegative, isDiff, isUp, isClosePause)]" @click="onClickOdd($event);">
      <div v-if="checkTitleBt()" style="padding: 17px 45%;" :title="getTitle()"></div>
      <template v-if="event.od"> 
        <template v-if="event.od[plyType]">
          <template v-if="event.od[plyType][betType]">
            <template v-if="event.od[plyType][betType][matchId]">
              <template v-if="checkOddValidation(event.od[plyType][betType][matchId][team])">
                <span class="yb-family-odds yb-number-bold match_details">
                  {{ getDecimalDisplay(event.od[plyType][betType][matchId][team]) }}
                </span>
              </template>
              <template v-else>
                <div class="lock m-icon"  style=""></div>
              </template>
            </template>
            <template v-else>
              <template v-if="event.od[plyType][betType][team+'od']">
                <template v-if="checkOddValidation(event.od[plyType][betType][team+'od'])">
                  <!-- <div class="oddsBet abcs" :class="getClass(event, isNegative, isDiff, isUp)" @click="onClickOdd($event);"> -->
                    <span class="yb-family-odds yb-number-bold match_details">
                      {{ getDecimalDisplay(event.od[plyType][betType][team+'od']) }}
                    </span>
                  <!-- </div> -->
                </template>
                <template v-else>
                  <div class="lock m-icon"  style="margin: auto;"></div>
                </template>
              </template>
              <template v-else>
                <div class="lock m-icon"  style="margin: auto;"></div>
              </template>
            </template>
          </template>
          <template v-else>
            <div class="lock m-icon"  style="margin: auto;"></div>
          </template>
        </template>
        <template v-else>
          <div class="lock m-icon"  style="margin: auto;"></div>
        </template>
      </template>
    </div>
  `,
  props: {
    event: null,
    team: null,
    plyType: null,
    betType: null,
    mode: null,
    match: null,
  },
  watch: {
    'event': {
      handler(val, oldVal) {
        if (this.match == 0 || this.match == 'a')
          this.matchId = 'a'
        else if (this.match == 1 || this.match == 'b')
          this.matchId = 'b'
        else if (this.match == 2 || this.match == 'c')
          this.matchId = 'c'
        else
          this.matchId = 'd'

        if([this.dbchBetType, this.rdbchBetType].includes(this.betType.toString())) {
          this.matchId = 'a'
        }
        
        if(this.isDefinedOdds(val)) {
          if(this.betType >= 59 && this.betType <= 73){
            this.classNegative(val.od[this.plyType][this.betType][this.matchId][this.team])  
          }else{
            this.classNegative(val.od[this.plyType][this.betType][this.team+'od'])
          }
          //check if immediate call
          if(oldVal && !this.refreshOdd){
            this.refreshOdd = false
            if(this.isDefinedOdds(oldVal)) {
              if(this.betType >= 59 && this.betType <= 73){
                this.diffOddsUpDown(val.od[this.plyType][this.betType][this.matchId][this.team], oldVal.od[this.plyType][this.betType][this.matchId][this.team])
              this.diffOdds(val.od[this.plyType][this.betType][this.matchId][this.team], oldVal.od[this.plyType][this.betType][this.matchId][this.team])  
              }else{
                this.diffOddsUpDown(val.od[this.plyType][this.betType][this.team+'od'], oldVal.od[this.plyType][this.betType][this.team+'od'])
                this.diffOdds(val.od[this.plyType][this.betType][this.team+'od'], oldVal.od[this.plyType][this.betType][this.team+'od'])
              }
            }
          } else if (this.refreshOdd) {
            this.refreshOdd = false
            this.isDiff = false
          } else if (!oldVal) { //when not same template
            this.refreshOdd = true
          }
        } else {
          this.isClosePause = true
        }
      },
      deep: true,
      immediate: true,
    },
  },
  data() {
    return {
      isNegative: false,
      isDiff: false,
      isUp: false,
      isClosePause: false,
      matchId: null,
      refreshOdd: false,
    }
  },
  methods: {
    getOdCls(mode, bt, event) {
      var a = ' odds-default'
      if (mode == 'ab') {
        a += ' odds-ou yb-number-font'
        a += ' odds-sc'
        if(bt=='4' || bt=='11' || bt=='12' || bt=='13'){
          a += ' ab-right'
        }
      } else {
        if(jQuery.inArray(bt, ['4','11','3','9','7','16','46','47','48','49','32','33','38','39','34','35','30','31']) != '-1'){
          //Handle odds at common with hdp/text on right of odds
          a += ' c-right'
        } else if(bt=='12' || bt=='13'){
          a += ' c-center'
        }
      }
      // style="position: absolute;inset: 0px;margin-right: 10px;" :style="{ 'justify-content': mode=='ab'&& betType!=4 && betType==1 ? 'center': 'right'}"
      return a
    },
    getClass(windowEvent, isNeg, isDif, isUp, isClosePause) {
      var classStr = ''
      var classMini = ''

      // if(this.sportMiniBet.allow && this.sportMiniBet.toggle && this.checkMiniBetUnique(windowEvent, this.getOddUniqueId(windowEvent))){
      //   classMini = ' selected panelActive'
      //   if(this.sportMiniBet.rightside){
      //     classMini = ' selected panelActive-bottomRight'
      //   }
      //   if(this.betForm.oddChg){
      //     classStr = 'indicator' 
      //   }
      // } 
      if(this.changeOdds){
        if (!this.refreshOdd && isDif) {
          classStr = 'indicator'  //indicatorUp
        }
      } else if (isClosePause) {
        classStr = ''
      } else {
        if (!this.refreshOdd && isDif) {  //refresh
          if(isUp){
            classStr = 'up'
          } else {
            classStr = 'down'
          }
        }
      }
      return classStr + classMini
    },
    getOddUniqueClass (event) {
      var classStr = ''
      
      if(this.isNegative) {
        classStr += 'ngve '
      }

      if(this.isDiff) {
        classStr += 'diff '
      }

      classStr += this.getOddUniqueId(event)
      return classStr
    },
    getOddUniqueId(event) {
      if(jQuery.inArray(this.betType, ['59','60','61','62','63','64','65','66','67','68','69','70','71','72','73']) != '-1'){
        return event.eveid + this.plyType + this.betType + this.team + this.matchId
      }else{
        return event.eveid + this.plyType + this.betType + this.team
      }
    },
    getDecimalDisplay(value) {
      if(this.$store.getters.account.oddsType=='am'){
        return parseFloat(value).toFixed(0);
      }
      return parseFloat(value).toFixed(2);
  },
    onClickOdd (windowEvent) {
      EventBus.$emit('returnBetTab')
      if (this.account.previewFlag && window._hasRedirect) {
        $('.login-redirect-dialog').show();
        return
      }
      if(this.event.od[this.plyType][this.betType] == undefined){
        return
      }else if ((this.betType >= 59 && this.betType <= 73) && this.event.od[this.plyType][this.betType][this.matchId][this.team]<=0){
        return
      }else if((this.$store.getters.account.oddsType != 'in' && this.$store.getters.account.oddsType != 'my' && this.$store.getters.account.oddsType != 'am') && this.event.od[this.plyType][this.betType][this.team]<=0){
        return
      }
      if(!this.account.previewFlag){
        var od = ''
        var uid = ''
        if(jQuery.inArray(this.betType, ['59','60','61','62','63','64','65','66','67','68','69','70','71','72','73']) != '-1'){
          od = this.event.od[this.plyType][this.betType][this.matchId][this.team]
          uid = this.event.eveid + this.plyType + this.betType + this.team + this.matchId
        }else{
          od = this.event.od[this.plyType][this.betType][this.team + 'od']
          uid = this.event.eveid + this.plyType + this.betType + this.team
        }

        var betForm = {
          title: this.$store.getters.selectedBettype.sprtTitleLang ,
          eveid: this.event.eveid,
          league: this.event.lgecapt,
          sprtid: this.event.sptid,
          plyType: this.plyType,
          betType: this.betType,
          ta: this.event.tacapt,
          tb: this.event.tbcapt,
          taid: this.event.taid,
          tbid: this.event.tbid,
          odd: od,
          rbscoa: 0,
          rbscob: 0,
          hdp: '0',
          dual: this.matchId != null ? this.matchId : 'a', //1x2 only a
          fav: '0',
          uniqueId: uid,
          eventObj: this.event,
        }

        if(this.event.rb) {
          if(this.event.rbinfo) {
            betForm.rbscoa = this.event.rbinfo.scoa
            betForm.rbscob = this.event.rbinfo.scob
          }
        }

        var or = this.$store.getters.sportAllBetLang['ALL_BET.LBL_OR']
        
        if(this.betType == '68' || this.betType == '69'){
          if(this.team == 'oddsha') { 
            betForm.tbetcapt = this.sportAllBetLang['ALL_BET.LBL_HOME_OR_DRAW']  +' '+ this.$store.getters.sportAllBetLang['ALL_BET.AND'] +' '+ this.$store.getters.sportAllBetLang['ALL_BET.LBL_OVER']
            betForm.tbetid = 'ha'
            betForm.tbet = 'ha'
          } else if (this.team == 'oddshb') {
            betForm.tbetcapt = this.sportAllBetLang['ALL_BET.LBL_HOME_OR_DRAW']  +' '+ this.$store.getters.sportAllBetLang['ALL_BET.AND'] +' '+ this.$store.getters.sportAllBetLang['ALL_BET.LBL_UNDER']
            betForm.tbetid = 'hb'
            betForm.tbet = 'hb'
          } else if (this.team == 'oddsda') { 
            betForm.tbetcapt = this.sportAllBetLang['ALL_BET.LBL_HOME_OR_AWAY'] +' '+ this.$store.getters.sportAllBetLang['ALL_BET.AND'] +' '+ this.$store.getters.sportAllBetLang['ALL_BET.LBL_OVER']
            betForm.tbetid = 'da'
            betForm.tbet = 'da'
          } else if (this.team == 'oddsdb') { 
            betForm.tbetcapt = this.sportAllBetLang['ALL_BET.LBL_HOME_OR_AWAY'] +' '+ this.$store.getters.sportAllBetLang['ALL_BET.AND'] +' '+ this.$store.getters.sportAllBetLang['ALL_BET.LBL_UNDER']
            betForm.tbetid = 'db'
            betForm.tbet = 'db'
          } else if (this.team == 'oddsaa') { 
            betForm.tbetcapt = this.sportAllBetLang['ALL_BET.LBL_AWAY_OR_DRAW'] +' '+ this.$store.getters.sportAllBetLang['ALL_BET.AND'] +' '+ this.$store.getters.sportAllBetLang['ALL_BET.LBL_OVER']
            betForm.tbetid = 'aa'
            betForm.tbet = 'aa'
          } else { 
            betForm.tbetcapt = this.sportAllBetLang['ALL_BET.LBL_AWAY_OR_DRAW'] +' '+ this.$store.getters.sportAllBetLang['ALL_BET.AND'] +' '+ this.$store.getters.sportAllBetLang['ALL_BET.LBL_UNDER']
            betForm.tbetid = 'ab'
            betForm.tbet = 'ab'
          }
        }else if(this.betType == '70' || this.betType == '71'){
          if(this.team == 'oddsha') { 
            betForm.tbetcapt = this.$store.getters.sportAllBetLang['ALL_BET.LBL_HOME_OR_DRAW'] +' '+ this.$store.getters.sportAllBetLang['ALL_BET.AND'] +' '+ this.$store.getters.sportAllBetLang['ALL_BET.LBL_YES']
            betForm.tbetid = 'ha'
            betForm.tbet = 'ha'
          } else if (this.team == 'oddshb') {
            betForm.tbetcapt = this.$store.getters.sportAllBetLang['ALL_BET.LBL_HOME_OR_DRAW'] +' '+ this.$store.getters.sportAllBetLang['ALL_BET.AND'] +' '+ this.$store.getters.sportAllBetLang['ALL_BET.LBL_NO']
            betForm.tbetid = 'hb'
            betForm.tbet = 'hb'
          } else if (this.team == 'oddsda') {
            betForm.tbetcapt = this.$store.getters.sportAllBetLang['ALL_BET.LBL_HOME_OR_AWAY'] +' '+ this.$store.getters.sportAllBetLang['ALL_BET.AND'] +' '+ this.$store.getters.sportAllBetLang['ALL_BET.LBL_YES']
            betForm.tbetid = 'da'
            betForm.tbet = 'da'
          } else if (this.team == 'oddsdb') {
            betForm.tbetcapt = this.$store.getters.sportAllBetLang['ALL_BET.LBL_HOME_OR_AWAY'] +' '+ this.$store.getters.sportAllBetLang['ALL_BET.AND'] +' '+ this.$store.getters.sportAllBetLang['ALL_BET.LBL_NO']
            betForm.tbetid = 'db'
            betForm.tbet = 'db'
          } else if (this.team == 'oddsaa') { 
            betForm.tbetcapt = this.$store.getters.sportAllBetLang['ALL_BET.LBL_AWAY_OR_DRAW'] +' '+ this.$store.getters.sportAllBetLang['ALL_BET.AND'] +' '+ this.$store.getters.sportAllBetLang['ALL_BET.LBL_YES']
            betForm.tbetid = 'aa'
            betForm.tbet = 'aa'
          } else { 
            betForm.tbetcapt = this.$store.getters.sportAllBetLang['ALL_BET.LBL_AWAY_OR_DRAW'] +' '+ this.$store.getters.sportAllBetLang['ALL_BET.AND'] +' '+ this.$store.getters.sportAllBetLang['ALL_BET.LBL_NO']
            betForm.tbetid = 'ab'
            betForm.tbet = 'ab'
          }
        }else if(this.betType == '72'){
          if(this.team == 'oddsha') { 
            betForm.tbetcapt = this.$store.getters.sportAllBetLang['ALL_BET.LBL_HOME_OR_DRAW'] +' '+ this.$store.getters.sportAllBetLang['ALL_BET.AND'] +' '+ this.event.tacapt
            betForm.tbetid = 'ha'
            betForm.tbet = 'ha'
          } else if (this.team == 'oddshb') {
            betForm.tbetcapt = this.$store.getters.sportAllBetLang['ALL_BET.LBL_HOME_OR_DRAW'] +' '+ this.$store.getters.sportAllBetLang['ALL_BET.AND'] +' '+ this.event.tbcapt
            betForm.tbetid = 'hb'
            betForm.tbet = 'hb'
          } else if (this.team == 'oddsda') {
            betForm.tbetcapt = this.$store.getters.sportAllBetLang['ALL_BET.LBL_HOME_OR_AWAY'] +' '+ this.$store.getters.sportAllBetLang['ALL_BET.AND'] +' '+ this.event.tacapt
            betForm.tbetid = 'da'
            betForm.tbet = 'da'
          } else if (this.team == 'oddsdb') {
            betForm.tbetcapt = this.$store.getters.sportAllBetLang['ALL_BET.LBL_HOME_OR_AWAY'] +' '+ this.$store.getters.sportAllBetLang['ALL_BET.AND'] +' '+ this.event.tbcapt
            betForm.tbetid = 'db'
            betForm.tbet = 'db'
          } else if (this.team == 'oddsaa') { 
            betForm.tbetcapt = this.$store.getters.sportAllBetLang['ALL_BET.LBL_AWAY_OR_DRAW'] +' '+ this.$store.getters.sportAllBetLang['ALL_BET.AND'] +' '+ this.event.tacapt
            betForm.tbetid = 'aa'
            betForm.tbet = 'aa'
          } else { 
            betForm.tbetcapt = this.$store.getters.sportAllBetLang['ALL_BET.LBL_AWAY_OR_DRAW'] +' '+ this.$store.getters.sportAllBetLang['ALL_BET.AND'] +' '+ this.event.tbcapt
            betForm.tbetid = 'ab'
            betForm.tbet = 'ab'
          }
        }else{
          if(this.team == 'ha') { //is bet home away
            betForm.tbetcapt = this.event.tacapt + or + this.event.tbcapt
            // betForm.tbetcapt =  this.$store.getters.sportAllBetLang['ALL_BET.LBL_HOME_OR_AWAY']
            betForm.tbetid = 'ha'
            betForm.tbet = 'ha'
          } else if (this.team == 'hd') { //is bet home draw
            betForm.tbetcapt = this.event.tacapt + or + this.$store.getters.sportAllBetLang['ALL_BET.LBL_DRAW']
            // betForm.tbetcapt =  this.$store.getters.sportAllBetLang['ALL_BET.LBL_HOME_OR_DRAW']
            betForm.tbetid = 'hd'
            betForm.tbet = 'hd'
          } else { //is bet away draw
            betForm.tbetcapt = this.event.tbcapt + or + this.$store.getters.sportAllBetLang['ALL_BET.LBL_DRAW']
            // betForm.tbetcapt =  this.$store.getters.sportAllBetLang['ALL_BET.LBL_AWAY_OR_DRAW']
            betForm.tbetid = 'ad'
            betForm.tbet = 'ad'
          }
        }

        if(this.$store.getters.selectedMarket == this.$store.getters.market.inPlayMarket.key) {
          var market = this.$store.getters.market.inPlayMarket
          betForm.plytypcapt = '(' + market.betLang + ') ' + this.plyType
        } else if (this.$store.getters.selectedMarket == this.$store.getters.market.earlyMarket.key) {
          // betForm.title = this.$store.getters.selectedBettype.sprtTitleLang + ' - ' + this.$store.getters.market.earlyMarket.betLang
        }

        // Check if current sel has selected, if true remove else add
        var indexx = _.findIndex(this.$store.getters.betForm, {
          'eveid': this.event.eveid,
          'plyType': this.plyType,
          'betType': this.betType,
          'tbet': betForm.tbet,
        });
        if(indexx > -1){
          var obj = {eveid: this.event.eveid}
          if(this.$store.getters.isBetCombo){
            obj = {clearType: '3', index: indexx}
          }
          this.$store.commit("BETCOMBO_AMOUNT", { spliceIndex: true, index: indexx });
          this.$store.commit("BETCOMBO_KEYBOARDALLOW", { spliceIndex: true, index: indexx });

          this.$store.dispatch("removeMatch", {
            // eveid: this.event.eveid,
            data: obj,
            callback: (() => {
              this.$store.commit("PARLAY_SELECTED", {
                remove: true,
                eveid: this.event.eveid,
              });
              var MID = $(windowEvent.target).closest('div[id]')[0].id
              // document.getElementById(MID).parentElement.classList.remove('active')
              $("[id="+MID+"]").closest('.c-bet-item.active').removeClass('active')
              if (this.$store.getters.betForm.length <= 0) {
                
                this.$store.commit("OPEN_BETFORM", false)
                this.$store.commit('ODD_SELECTED', false)
                this.$store.commit("SHOW_BETFORM_MENU", false);
                this.$store.commit('SELECTED_TAB', 'betTab')
                return;
              } else {
                this.$store.commit('OPEN_BETFORM', true)
              }
              this.$store.dispatch("getBettingInfo", {
                callback: ((res) => {
                  this.$store.commit("SPORT_MAPPING_BETTING", {
                    newBettingList: res.SYSTEM_DATA.betting,
                    oldBettingList: this.$store.getters.betForm,
                  });
                  // this.refreshTimer();
                  // this.isReloading = false;
                }).bind(this),
              });
            }).bind(this),
          });
        } else {
          //betcombo validate max betcombo wager
          if(this.$store.getters.isBetCombo && this.$store.getters.betForm.length==this.betComboMax){
            var chkRes = this.checkBetComboMax(betForm)
            if(chkRes){
              return
            }
          }
          // parlay
          if(this.$store.getters.selectedBettype.betTypId == '5' && this.$store.getters.betting.minMax!=undefined && this.$store.getters.betting.minMax.maxCombo!=undefined){
            if(this.$store.getters.betForm.length==this.$store.getters.betting.minMax.maxCombo){
              let vue = this
              let maxMulpComboMsg = this.$store.getters.betLang['BETTING.HIT_MAX_COMBO']
              this.$store.commit('DIALOG_TOGGLE',{
                show: true,
                msg: maxMulpComboMsg
              })
              // this.$store.commit('JS_ERR', {error:true, msg:maxMulpComboMsg})
              setTimeout(function() {
                // vue.$store.commit('JS_ERR', {error:false})
                vue.$store.commit('DIALOG_TOGGLE', {reset:true})
              }, 5000);
              return
            }
          }
          
          this.$store.dispatch('getLatestInfo', {
            data: betForm,
            callback: ((res)=> {
              this.$store.commit('OPEN_BETFORM', true)
              this.oddSelectHighlight(windowEvent, betForm)
              
              if(res.SYSTEM_DATA.status != 'FAIL') {
                if(this.$store.getters.miniNormal==1){
                  this.showMiniBet(windowEvent);
                  if(this.$store.getters.sportMiniBet.toggle){
                    EventBus.$emit('expandMini')
                  }
                }
                if(!this.$store.getters.isBetCombo){
                  this.$store.commit('SPORT_MINIBET_BETAMOUNT', 0)
                  EventBus.$emit('resetKeyboard')
                }
                // this.$store.commit('SPORT_MINIBET_BETAMOUNT', 0)
                this.$store.commit('ODD_SELECTED', true)
                // this.$store.commit('SELECTED_BETTAB', true)
                this.$store.commit('BET_FORM', {
                  newBettingList: res.SYSTEM_DATA.betting,
                  oldBetData: betForm,
                    
                })
                //multisingle & > 1 wager
                if(this.$store.getters.isBetCombo && this.$store.getters.betForm.length>1){ 
                  EventBus.$emit('clearAllBetComboAmount');
                  EventBus.$emit('resetKeyboard')
                }
                if (windowEvent) {
                  this.$store.commit('PARLAY_SELECTED', {
                    class: $(windowEvent.target).parents('.b_cen'),
                    eveid: this.event.eveid
                  })
                }
                if(windowEvent){
                  this.$store.commit('PARLAY_SELECTED', {
                    class : $(windowEvent.target).parents('.b_cen'),
                    eveid: this.event.eveid
                  })
                }
              } else if (res.SYSTEM_DATA.status == 'FAIL') {
                if(this.$store.getters.miniNormal==1){
                  this.showMiniBet(windowEvent);
                }
                
                if(!this.$store.getters.isBetCombo){
                  this.$store.commit('SPORT_MINIBET_BETAMOUNT', 0)
                }
                this.$store.commit('ODD_SELECTED', true)
                // this.$store.commit('SELECTED_BETTAB', true)
                this.$store.commit('BET_FORM', {
                  newBettingList: res.SYSTEM_DATA.betting,
                  oldBetData: betForm
                })
                if (windowEvent) {
                  this.$store.commit('PARLAY_SELECTED', {
                    class: $(windowEvent.target).parents('.b_rig'),
                    eveid: this.event.eveid
                  })
                }
              }
            }).bind(this)
          })
        }

        
      }
    },
    classNegative (val, oldVal) {
      this.isNegative = val < 0 ? true : false
    },
    diffOdds (val, oldVal) {
      this.isDiff = val != oldVal ? true : false
    },
    diffOddsUpDown (val, oldVal) {
      this.isUp = parseFloat(val) > parseFloat(oldVal) ? true : false
    },
    isDefinedOdds (val) {
      var isDefinedOdds = false
      if(typeof val.od != 'undefined' ){
        if(typeof val.od[this.plyType] != 'undefined' ) {
          if(this.betType >= 59 && this.betType <= 73){
            if(typeof val.od[this.plyType][this.betType] != 'undefined' ) {
              if (typeof val.od[this.plyType][this.betType][this.matchId][this.team] != 'undefined' ) {
                isDefinedOdds = true
              }
            }
          }else{
            if(typeof val.od[this.plyType][this.betType] != 'undefined' ) {
              if (typeof val.od[this.plyType][this.betType][this.team+'od'] != 'undefined' ) {
                isDefinedOdds = true
              }
            }
          }
        }
      }
      return isDefinedOdds
    },
    checkTitleBt() {
      if([this.dbchBetType, this.rdbchBetType ,this.dbchftsBetType, this.dbchouBetType, this.rdbchouBetType, this.dbchbttsBetType, this.rdbchbttsBetType].includes(this.betType.toString())) {
        return true
      } 
      return false
    },
    getTitle(){
      // 72 dbch & fts
      if(this.betType == this.dbchftsBetType) {
        if(this.team == 'oddsha') { 
          return this.$store.getters.sportAllBetLang['ALL_BET.LBL_HOME_OR_DRAW'] +' '+ this.$store.getters.sportAllBetLang['ALL_BET.AND'] +' '+ this.event.tacapt
        } else if (this.team == 'oddshb') {
          return this.$store.getters.sportAllBetLang['ALL_BET.LBL_HOME_OR_DRAW'] +' '+ this.$store.getters.sportAllBetLang['ALL_BET.AND'] +' '+ this.event.tbcapt
        } else if (this.team == 'oddsda') {
          return this.$store.getters.sportAllBetLang['ALL_BET.LBL_HOME_OR_AWAY'] +' '+ this.$store.getters.sportAllBetLang['ALL_BET.AND'] +' '+ this.event.tacapt
        } else if (this.team == 'oddsdb') {
          return this.$store.getters.sportAllBetLang['ALL_BET.LBL_HOME_OR_AWAY'] +' '+ this.$store.getters.sportAllBetLang['ALL_BET.AND'] +' '+ this.event.tbcapt
        } else if (this.team == 'oddsaa') { 
          return this.$store.getters.sportAllBetLang['ALL_BET.LBL_AWAY_OR_DRAW'] +' '+ this.$store.getters.sportAllBetLang['ALL_BET.AND'] +' '+ this.event.tacapt
        } else { 
          return this.$store.getters.sportAllBetLang['ALL_BET.LBL_AWAY_OR_DRAW'] +' '+ this.$store.getters.sportAllBetLang['ALL_BET.AND'] +' '+ this.event.tbcapt
        }
      }
      // dbch & ou
      else if(this.betType == this.dbchouBetType || this.betType == this.rdbchouBetType) {
        if(this.team == 'oddsha') { 
          return this.sportAllBetLang['ALL_BET.LBL_HOME_OR_DRAW']  +' '+ this.$store.getters.sportAllBetLang['ALL_BET.AND'] +' '+ this.$store.getters.sportAllBetLang['ALL_BET.LBL_OVER']
        } else if (this.team == 'oddshb') {
          return this.sportAllBetLang['ALL_BET.LBL_HOME_OR_DRAW']  +' '+ this.$store.getters.sportAllBetLang['ALL_BET.AND'] +' '+ this.$store.getters.sportAllBetLang['ALL_BET.LBL_UNDER']
        } else if (this.team == 'oddsda') { 
          return this.sportAllBetLang['ALL_BET.LBL_HOME_OR_AWAY'] +' '+ this.$store.getters.sportAllBetLang['ALL_BET.AND'] +' '+ this.$store.getters.sportAllBetLang['ALL_BET.LBL_OVER']
        } else if (this.team == 'oddsdb') { 
          return this.sportAllBetLang['ALL_BET.LBL_HOME_OR_AWAY'] +' '+ this.$store.getters.sportAllBetLang['ALL_BET.AND'] +' '+ this.$store.getters.sportAllBetLang['ALL_BET.LBL_UNDER']
        } else if (this.team == 'oddsaa') { 
          return this.sportAllBetLang['ALL_BET.LBL_AWAY_OR_DRAW'] +' '+ this.$store.getters.sportAllBetLang['ALL_BET.AND'] +' '+ this.$store.getters.sportAllBetLang['ALL_BET.LBL_OVER']
        } else { 
          return this.sportAllBetLang['ALL_BET.LBL_AWAY_OR_DRAW'] +' '+ this.$store.getters.sportAllBetLang['ALL_BET.AND'] +' '+ this.$store.getters.sportAllBetLang['ALL_BET.LBL_UNDER']
        }
      }
      else if(this.betType == this.dbchbttsBetType || this.betType == this.rdbchbttsBetType) {
        if(this.team == 'oddsha') { 
          return this.$store.getters.sportAllBetLang['ALL_BET.LBL_HOME_OR_DRAW'] +' '+ this.$store.getters.sportAllBetLang['ALL_BET.AND'] +' '+ this.$store.getters.sportAllBetLang['ALL_BET.LBL_YES']
        } else if (this.team == 'oddshb') {
          return this.$store.getters.sportAllBetLang['ALL_BET.LBL_HOME_OR_DRAW'] +' '+ this.$store.getters.sportAllBetLang['ALL_BET.AND'] +' '+ this.$store.getters.sportAllBetLang['ALL_BET.LBL_NO']
        } else if (this.team == 'oddsda') {
          return this.$store.getters.sportAllBetLang['ALL_BET.LBL_HOME_OR_AWAY'] +' '+ this.$store.getters.sportAllBetLang['ALL_BET.AND'] +' '+ this.$store.getters.sportAllBetLang['ALL_BET.LBL_YES']
        } else if (this.team == 'oddsdb') {
          return this.$store.getters.sportAllBetLang['ALL_BET.LBL_HOME_OR_AWAY'] +' '+ this.$store.getters.sportAllBetLang['ALL_BET.AND'] +' '+ this.$store.getters.sportAllBetLang['ALL_BET.LBL_NO']
        } else if (this.team == 'oddsaa') { 
          return this.$store.getters.sportAllBetLang['ALL_BET.LBL_AWAY_OR_DRAW'] +' '+ this.$store.getters.sportAllBetLang['ALL_BET.AND'] +' '+ this.$store.getters.sportAllBetLang['ALL_BET.LBL_YES']
        } else { 
          return this.$store.getters.sportAllBetLang['ALL_BET.LBL_AWAY_OR_DRAW'] +' '+ this.$store.getters.sportAllBetLang['ALL_BET.AND'] +' '+ this.$store.getters.sportAllBetLang['ALL_BET.LBL_NO']
        }
      }
      else if(this.betType == this.dbchBetType || this.betType == this.rdbchBetType) {
        if(this.team == 'ha') { //is bet home away
          return this.$store.getters.sportAllBetLang['ALL_BET.LBL_HOME_OR_AWAY']
        } else if (this.team == 'hd') { //is bet home draw
          return this.$store.getters.sportAllBetLang['ALL_BET.LBL_HOME_OR_DRAW']
        } else { //is bet away draw
          return this.$store.getters.sportAllBetLang['ALL_BET.LBL_AWAY_OR_DRAW']
        }
      }
    },
  },
  beforeMount() {
    EventBus.$on(['refreshOdd'], ((params) => {
      if (params == false) {
        this.refreshOdd = false // change market, change page, change parlayEarlyDate
      } else {
        this.refreshOdd = true // change odd type, refresh button
      }
    }).bind(this))

    EventBus.$on(['diffOdd'], ((params) => {
      if(typeof this.event.all == 'undefined') {
        if(this.isDefinedOdds(this.event) && this.isDefinedOdds(params)) {
          this.diffOddsUpDown(params.od[this.plyType][this.betType][this.team+'od'], this.event.od[this.plyType][this.betType][this.team+'od'])
          this.diffOdds(params.od[this.plyType][this.betType][this.team+'od'], this.event.od[this.plyType][this.betType][this.team+'od'])
          this.$forceUpdate()
        }
      }
    }).bind(this))
  },
  mounted(){
    this.$store.getters.betForm.forEach(value => {
      var MID = value.uniqueId;
      $("[id="+MID+"]").closest('.c-bet-item').addClass('active')
    })
  }
})



// WEBPACK FOOTER //
// ./resources/wob/vue/components/odd-dbch.js